module.exports = __webpack_public_path__ + "static/media/Logo-JML-Rose.2dff4daf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/Logo-JML-Rose.svg
// module id = 470
// module chunks = 0